export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : ''
        this.name = item != null ? item.name : ''
        this.permissionIds = item != null ? item.permissions.map(a => a.id) : []
        this.accessToEverything = item != null ? item.accessToEverything : false;
        this.userIds = item != null ? item.users.map(a => a.id) : []
        this.availableForEveryOne = item != null ? item.availableForEveryOne : false;
    }
}